import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { AdminHeader } from "./admin-header";
import { AdminSidebar } from "./admin-sidebar";
import { SettingsTabs } from "./settings-tabs";

interface AdminLayoutProps {
	children: ReactNode;
}

export function AdminLayout({ children }: AdminLayoutProps) {
	const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
		const saved = localStorage.getItem("admin-sidebar-collapsed");
		return saved ? JSON.parse(saved) : false;
	});

	useEffect(() => {
		localStorage.setItem(
			"admin-sidebar-collapsed",
			JSON.stringify(sidebarCollapsed),
		);
	}, [sidebarCollapsed]);

	return (
		<div className="flex h-screen flex-col overflow-hidden">
			<AdminHeader
				sidebarCollapsed={sidebarCollapsed}
				onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
			/>
			<div className="flex flex-1 overflow-hidden">
				<AdminSidebar collapsed={sidebarCollapsed} />
				<main className="flex-1 overflow-auto p-6">
					<SettingsTabs />
					{children}
				</main>
			</div>
		</div>
	);
}
